import apiService from 'src/enviroment';

export const SITE_KEY = '6LftY-4ZAAAAAN6id-q4pryn_FYVa7Kb6eAdpmwQ';

const credentialService = {
  putCredencial: (body) => apiService.put('/credenciales/obtener/', body),
  loginCapcha: (body) => apiService.post('/credenciales/obtener/', body),
  recoverEmail: (body) => apiService.post('/credenciales/recuperacion/', body),
  putUpdatePassword: (body) => apiService.put('/credenciales/recuperacion/', body),
  removeSesion: () => apiService.delete('/credenciales/obtener/'),
};

export default credentialService;
